(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mr-site-header')) {
    customElements.define('mr-site-header', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.toggleButton = this.querySelector('[data-menu-toggle]');
        this.navigation = this.querySelector('[data-navigation]');
        if (!this.toggleButton || !this.navigation) return;
        this.setAttribute('data-enhanced', '');
        this.closeMenu();
        this.toggleButton.addEventListener('click', () => {
          const open = this.toggleButton.getAttribute('aria-expanded') !== 'true';
          this.toggleButton.setAttribute('aria-expanded', String(open));
          this.toggleAttribute('data-menu-open', open);
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.hasAttribute('data-menu-open')) {
            this.closeMenu();
            this.toggleButton.focus();
            event.preventDefault();
          }
        }, options);
        this.navigation.addEventListener('click', (event) => {
          if (event.target.closest('a')) this.closeMenu();
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.closeMenu();
        }, options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.closeMenu();
        }, options);
        this.desktopMedia = window.matchMedia('(min-width: 1241px)');
        this.desktopMedia.addEventListener('change', () => this.closeMenu(), options);
      }
      closeMenu() {
        this.toggleButton?.setAttribute('aria-expanded', 'false');
        this.removeAttribute('data-menu-open');
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
